import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import ADataGrid from "../../../../manage/common/data-grid/ADataGrid";
import {
  gridStyles,
  gridComponents,
} from "../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { editCellContainerStyle } from "../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { saveOrDeleteMsg } from "../../../edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { AGridColDef } from "../../../../manage/common/data-grid/ADataGridColDef";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import moment from "moment";
import {
  ActionsCellComponent,
  StatusCellComponent,
} from "../../studentFinancials/paymentGatewaysConfiguration/common";
import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseSquareBlack.svg";
import ALoader from "views/pages/manage/common/a-loader";
import NoRowOverlay from "../../holidayMaster/NoRowOverlay";
import {
  isObjEmpty,
  generateRandomId,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";
import { Tooltip } from "@mui/material";
import { ReactComponent as EyeIcon } from "../../../../../../assets/img/svg/eyeIcon.svg";
import { regex } from "views/pages/manage/common/constant";
import { statusStyle } from "../constants";
import CustomCopyToClipboard from "views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard";

const SchoolListComponent = ({
  rows = [],
  isLoading,
  setIsLoading,
  totalRecords = 0,
  onChangeHandler,
  currentPage,
}) => {
  const [rowModesModel, setRowModesModel] = useState({});
  const [rowForm, setRowForm] = useState({});
  const [rowData, setRowData] = useState(rows);

  const columns = [
    new AGridColDef("id", "School ID")
      .setMinWidth(110)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
            <CustomCopyToClipboard textToCopy={params?.value} />
          </>

        ) : (
          <>-</>
        )
      ),
    new AGridColDef("name", "Name")
      .setMinWidth(140)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("shortDescription", "Short Desc")
      .setMinWidth(140)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("board", "Board", false)
      .setMinWidth(90)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("type", "Type", false)
      .setMinWidth(90)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    // new AGridColDef("region", "Region", false)
    //   .setMinWidth(80)
    //   .setFlex(1)
    //   .editable(true)
    //   .setValueGetter((params) => params?.value)
    //   .renderCellComponent((params) => (
    //     params?.value ? (
    //       <>
    //         <Tooltip title={`${params?.value}`}>
    //           <div className={`ellipsis-text-container`}>
    //             {params?.value}
    //           </div>
    //         </Tooltip>
    //       </>
    //     ) : (<>-</>)
    //   )),
    new AGridColDef("state", "State", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("city", "City")
      .setMinWidth(120)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("pincode", "Pincode")
      .setMinWidth(100)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("branch", "Branch", false)
      .setMinWidth(80)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${(params?.value).join(", ")}`}>
              <div className={`ellipsis-text-container`}>
                {(params?.value).join(", ")}
              </div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("effectiveDate", "Effective Date", false)
      .setMinWidth(140)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${moment(params?.value).format("DD MMM YYYY")}`}>
              <div className={`ellipsis-text-container`}>
                {`${moment(params?.value).format("DD MMM YYYY")}`}
              </div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("updatedOn", "Last Updated On", false)
      .setMinWidth(140)
      .setFlex(1)
      .editable(true)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${moment(params?.value).format("DD-MMM-YYYY")}`}>
              <div className={`ellipsis-text-container`}>
                {`${moment(params?.value).format("DD-MMM-YYYY")}`}
              </div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("status", "Status", false)
      .setMinWidth(100)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params?.value)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            <Tooltip title={`${params?.value}`}>
              <div
                style={
                  params?.value?.toLowerCase() === "active"
                    ? statusStyle?.active
                    : statusStyle?.inactive
                }
                className={`ellipsis-text-container`}
              >
                {params?.value}
              </div>
            </Tooltip>
          </>
        ) : (
          <></>
        )
      ),
    new AGridColDef("actions", "Action", false)
      .setMinWidth(120)
      .setFlex(1)
      .editable(true)
      .pinColumnLast(true)
      .renderCellComponent((params) => (
        <>
          <Tooltip title={"View School"}>
            <span className="cursor">
              <EyeIcon
                onClick={() => {
                  const url = `${
                    window.location.origin
                  }/#/admin/master/schoolMaster?isView=${true}&schoolId=${
                    params?.row?.id
                  }`;

                  // Open the new tab with the constructed URL
                  window.open(url, "_blank").focus();
                }}
              />
            </span>
          </Tooltip>
        </>
      )),
  ];

  useEffect(() => {
    setRowData(rows);
  }, [rows]);

  return (
    <>
      {isLoading && <ALoader position="fixed" />}
      <ADataGrid
        removeWrapperContainer
        autoHeight
        sx={{
          ...gridStyles,
        }}
        rowModesModel={rowModesModel}
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={totalRecords}
        currentPage={currentPage}
        nextButtonHandler={onChangeHandler}
        hideFooterSelectedRowCount={true}
        pinLastColumn
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={isLoading ? "Loading..." : null} />
          ),
        }}
      />
    </>
  );
};

export default SchoolListComponent;
